export const adminLanguageOptions: { value: string, label: string }[] = [
    { label: 'English', value: 'en-US' }
]
